import { formatStdDateStamp } from 'app/utils/datetime/helpers'

export const automationsTracingFeatureReleaseDate = '2023-12-07'
export const outOfTraceableRangeAlert = `Emails were added to Automation Activity on the ${formatStdDateStamp(
  automationsTracingFeatureReleaseDate,
)} so may be incomplete for this date range.`
